export const GS_PATH = process.env.REACT_APP_AIMO_PARKING_BUCKET;
